import { ICSIPerformanceMetricsResponse, IMetric } from "../types/queries";

export interface IMetricsData {
	name: number;
	key: string;
	Dealership?: number;
	You?: number;
	Region?: number;
	amt: number;
}

export interface CapitalizedMetricsData {
	franchise: string;
	salesMetrics: IMetricsData[];
	serviceMetrics: IMetricsData[];
}

const LAST_EMPTY_MONTHS_TO_REMOVE = 2;

export const capitalizeObjectKeys = (dataCSI: ICSIPerformanceMetricsResponse[]): CapitalizedMetricsData[] => {
	const transFormMetrics = (itemObj: IMetric, index: number) => {
		const formattedData = {
			name: index + 1,
			key: itemObj?.key ?? "",
			amt: itemObj?.amt ?? 0,
		};

		if (index >= dataCSI.length - LAST_EMPTY_MONTHS_TO_REMOVE && !itemObj.dealership && !itemObj.region && !itemObj.you) {
			return formattedData;
		}

		return {
			...formattedData,
			Dealership: itemObj?.dealership,
			You: itemObj?.you,
			Region: itemObj?.region,
		};
	};

	return dataCSI.map((element) => ({
		franchise: element?.franchise,
		salesMetrics: element?.salesMetrics?.map(transFormMetrics),
		serviceMetrics: element?.serviceMetrics?.map(transFormMetrics),
	}));
};
